import { defineStore } from 'pinia'
import { trackPostHogEvent } from '@/utils/posthog'

export const useSnackbarStore = defineStore({
  id: 'snackbar',
  state: () => ({
    text: '',
    color: 'primary',
    timeout: 6000,
    show: false
  }),
  actions: {
    showSnackbar({
      text,
      color,
      timeout
    }: {
      text: string
      color: string
      timeout: number
    }) {
      this.text = text
      this.color = color
      this.timeout = timeout
      this.show = true

      if (text && (color === 'error' || /erro|falha/i.test(text))) {
        trackPostHogEvent('error_shown', {
          text,
          route_path:
            typeof window !== 'undefined' ? window.location.pathname : ''
        })
      }

      setTimeout(() => {
        this.show = false
      }, timeout)
    },
    closeSnackbar() {
      this.show = false
    }
  }
})
